import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Paper,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Grid,
  ButtonGroup,
  Button
} from '@mui/material';
import ListItem from './components/ListItem';
// Actions
import { getMissions } from 'actions/orderActions';
import Page from '../../components/Page/Page';

const MissionList = ({ missions, requestMissions }) => {
  const [page, setPage] = useState(1);

  useEffect(() => {
    requestMissions(page);
  }, [requestMissions, page]);

  return (
    <Page className="p-6">
      <Grid
        container
        className="my-2"
        spacing={1}
        direction="column"
        alignItems="center">
        <Grid item>
          <Paper>
            <ButtonGroup>
              <Button
                onClick={() => {
                  if (page > 1) {
                    setPage(page - 1);
                  }
                }}>
                &#x3C;
              </Button>
              <Button>{page}</Button>
              <Button onClick={() => setPage(page + 1)}>&#x3E;</Button>
            </ButtonGroup>
          </Paper>
        </Grid>
      </Grid>
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Status</TableCell>
              <TableCell>Mission ID</TableCell>
              <TableCell>Created</TableCell>
              <TableCell>Origin Order ID</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {missions.map(mission => (
              <ListItem mission={mission} key={mission.id} />
            ))}
          </TableBody>
        </Table>
      </Paper>
      <Grid
        container
        className="my-2"
        spacing={1}
        direction="column"
        alignItems="center">
        <Grid item>
          <Paper>
            <ButtonGroup>
              <Button
                onClick={() => {
                  if (page > 1) {
                    setPage(page - 1);
                  }
                }}>
                &#x3C;
              </Button>
              <Button>{page}</Button>
              <Button onClick={() => setPage(page + 1)}>&#x3E;</Button>
            </ButtonGroup>
          </Paper>
        </Grid>
      </Grid>
    </Page>
  );
};

const mapStateToProps = state => ({
  missions: state.orders.missions.list
});

const mapDispatchToProps = dispatch => ({
  requestMissions: page => dispatch(getMissions(page))
});

MissionList.propTypes = {
  missions: PropTypes.arrayOf(PropTypes.object),
  requestMissions: PropTypes.func.isRequired
};

MissionList.defaultProps = {
  missions: []
};

export default connect(mapStateToProps, mapDispatchToProps)(MissionList);
